import React, { useEffect, useState } from 'react';
import { app } from '../firebase'; // Assurez-vous d'importer votre configuration Firebase
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, setDoc, collection, query, where, getDocs } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';

import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';
import {eye} from 'react-icons-kit/feather/eye';
import { LEGAL_URLS } from '../helpers/Constants';

const auth = getAuth(app);
const firestore = getFirestore(app);

function SignUp() {
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [company, setCompany] = useState('');
  const [addressVisible, setAddressVisible] = useState(false);
  const [address, setAddress] = useState('');
  const [zip, setZip] = useState('');
  const [city, setCity] = useState('');
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [coownershipId, setCoownershipId] = useState('');
  const [error, setError] = useState('');
  const [errorCodeImmeuble, setErrorCodeImmeuble] = useState('');
  const [successCodeImmeuble, setSuccessCodeImmeuble] = useState('');
  
  // État pour l'affichage des mots de passe
  const [passwordType, setPasswordType] = useState('password');
  const [passwordIcon, setPasswordIcon] = useState(eyeOff);
  const [confirmPasswordType, setConfirmPasswordType] = useState('password');
  const [confirmPasswordIcon, setConfirmPasswordIcon] = useState(eyeOff);
  const [acceptedCgu, setAcceptedCgu] = useState(false);
  const [acceptedPrivacyPolicy, setAcceptedPrivacyPolicy] = useState(false);
  const [acceptedSubcontracting, setAcceptedSubcontracting] = useState(false);

  const navigate = useNavigate();
  const isRentalManagerSignup = status === 'gestionnaireLocatif';

  // Vérification du code immeuble
  useEffect(() => {
    if (code.length === 6) {
      checkCoownership();
    } else {
      setSuccessCodeImmeuble('');
    }
  }, [code]);

  useEffect(() => {
    if (status !== 'gestionnaireLocatif') {
      setAcceptedSubcontracting(false);
    }
  }, [status]);

  const checkCoownership = async () => {
    try {
      // Vérification prestataire
      const providerQuery = query(
        collection(firestore, 'coownership'),
        where('codeProvider', '==', code),
        where('status', '==', 'activated')
      );
      
      const providerQuerySnapshot = await getDocs(providerQuery);
      
      if (!providerQuerySnapshot.empty) {
        setStatus('prestataire');
        setCoownershipId(providerQuerySnapshot.docs[0].id);
        autoCompleteAddress(providerQuerySnapshot);
        return;
      }


      // Vérification gestionnaire locatif
      const rentalManagerQuery = query(
        collection(firestore, 'coownership'),
        where('codeRentalManager', '==', code),
        where('status', '==', 'activated')
      );
      
      const rentalManagerQuerySnapshot = await getDocs(rentalManagerQuery);
      
      if (!rentalManagerQuerySnapshot.empty) {
        setStatus('gestionnaireLocatif');
        setCoownershipId(rentalManagerQuerySnapshot.docs[0].id);
        autoCompleteAddress(rentalManagerQuerySnapshot);
        return;
      }

      setErrorCodeImmeuble("Le code immeuble n'est pas valide");
      setSuccessCodeImmeuble('');
      
    } catch (error) {
      console.error("Erreur lors de la vérification du code:", error);
      setErrorCodeImmeuble("Erreur lors de la vérification du code");
    }
  };

  const autoCompleteAddress = (querySnapshot) => {
    const data = querySnapshot.docs[0].data();
    setAddress(data.address || '');
    setCity(data.city || '');
    setZip(data.zip || '');
    
    setAddressVisible(true);
    setErrorCodeImmeuble('');
    setSuccessCodeImmeuble('Code immeuble valide');
  };

  // Validation des champs
  const validateFirstname = (firstname) => {
    if (!firstname) return "Le prénom est obligatoire";
    if (firstname.length < 2) return "Le prénom doit contenir au moins 2 caractères";
    return true;
  };

  const validateLastname = (lastname) => {
    if (!lastname) return "Le nom est obligatoire";
    if (lastname.length < 2) return "Le nom doit contenir au moins 2 caractères";
    return true;
  };

  const validateCompany = (company) => {
    if (!company) return "Le nom de l'entreprise est obligatoire";
    if (company.length < 2) return "Le nom de l'entreprise doit contenir au moins 2 caractères";
    return true;
  };

  const validateCode = (code) => {
    if (!code) return "Le code immeuble est obligatoire";
    if (code.length !== 6) return "Le code immeuble doit contenir 6 caractères";
    return true;
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    if (!phone) return "Le numéro de téléphone est obligatoire";
    if (!phoneRegex.test(phone)) return "Le numéro de téléphone doit contenir 10 chiffres";
    return true;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return "L'email est obligatoire";
    if (!emailRegex.test(email)) return "Format d'email invalide";
    return true;
  };

  const validatePassword = (password) => {
    if (!password) return "Le mot de passe est obligatoire";
    if (password.length < 6) return "Le mot de passe doit contenir au moins 6 caractères";
    return true;
  };

  const validateConfirmPassword = (password, confirmPassword) => {
    if (!confirmPassword) return "La confirmation du mot de passe est obligatoire";
    if (password !== confirmPassword) return "Les mots de passe ne correspondent pas";
    return true;
  };

  // Gestion des erreurs Firebase
  const handleErrorSignup = (errorCode) => {
    switch(errorCode) {
      case 'auth/email-already-in-use':
        return "Cette adresse email est déjà utilisée";
      case 'auth/invalid-email':
        return "L'adresse email n'est pas dans un bon format";
      case 'auth/weak-password':
        return "Le mot de passe est trop faible";
      default:
        return "Une erreur est survenue lors de la création du compte";
    }
  };

  // Toggle affichage mot de passe
  const handleTogglePassword = () => {
    if (passwordType === 'password') {
      setPasswordIcon(eye);
      setPasswordType('text');
    } else {
      setPasswordIcon(eyeOff);
      setPasswordType('password');
    }
  };

  // Toggle affichage confirmation mot de passe
  const handleToggleConfirmPassword = () => {
    if (confirmPasswordType === 'password') {
      setConfirmPasswordIcon(eye);
      setConfirmPasswordType('text');
    } else {
      setConfirmPasswordIcon(eyeOff);
      setConfirmPasswordType('password');
    }
  };

  const handleSignup = async () => {
    // Validation des champs
    const firstnameError = validateFirstname(firstname);
    if (firstnameError !== true) {
      setError(firstnameError);
      return;
    }

    const lastnameError = validateLastname(lastname);
    if (lastnameError !== true) {
      setError(lastnameError);
      return;
    }

    const companyError = validateCompany(company);
    if (companyError !== true) {
      setError(companyError);
      return;
    }

    const codeError = validateCode(code);
    if (codeError !== true) {
      setError(codeError);
      return;
    }

    const phoneError = validatePhone(phone);
    if (phoneError !== true) {
      setError(phoneError);
      return;
    }

    const emailError = validateEmail(email);
    if (emailError !== true) {
      setError(emailError);
      return;
    }

    const passwordError = validatePassword(password);
    if (passwordError !== true) {
      setError(passwordError);
      return;
    }

    const confirmPasswordError = validateConfirmPassword(password, confirmPassword);
    if (confirmPasswordError !== true) {
      setError(confirmPasswordError);
      return;
    }

    // Vérification que le code immeuble est valide
    if (!addressVisible) {
      setError("Veuillez entrer un code immeuble valide");
      return;
    }

    if (!acceptedCgu) {
      setError("Vous devez accepter les CGU");
      return;
    }

    if (!acceptedPrivacyPolicy) {
      setError("Vous devez accepter la politique de confidentialité");
      return;
    }

    if (isRentalManagerSignup && !acceptedSubcontracting) {
      setError("Vous devez accepter l'accord de sous-traitance");
      return;
    }

    setLoading(true);

    try {
      // Création de l'utilisateur dans Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, email.trim(), password);
      const user = userCredential.user;

      if (user) {
        // Enregistrement des infos dans Firestore
        await setDoc(doc(firestore, "users", user.uid), {
          firstname,
          lastname,
          company: company.trim(),
          phone,
          email: email.trim(),
          status,
          lastCoownershipLoaded: doc(firestore, 'coownership', coownershipId),
          coownershipId: [{ coownershipReference: doc(firestore, 'coownership', coownershipId) }],
        });

        let userData = {};
      
        userData = {
          dateRegister: new Date(),
          firstname,
          lastname,
          company: company.trim(),
          email: email.trim(),
          phone
        };

        // Enregistrement des infos dans la sous-collection usersProvider
        if(status === 'prestataire') {
          await setDoc(
            doc(firestore, "coownership", coownershipId, "usersProvider", user.uid),
            userData
          );
        }

        // Enregistrement des infos dans la sous-collection usersRentalManager
        if(status === 'gestionnaireLocatif') {
          await setDoc(
            doc(firestore, "coownership", coownershipId, "usersRentalManager", user.uid),
            userData
          );
        }
        
        // Message de succès et redirection
        alert("Compte créé avec succès");
        navigate('/dashboard');
      }
    } catch (error) {
      console.error("Erreur d'inscription:", error);
      setError(handleErrorSignup(error.code));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-semibold mb-4 text-primary text-center">Création de compte</h2>
        
        {/* Prénom et Nom */}
        <div className="flex space-x-4 mb-4">
          <div className="w-1/2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Prénom</label>
            <input
              type="text"
              placeholder="Prénom"
              className="w-full p-2 border rounded-md"
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
            />
          </div>
          <div className="w-1/2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Nom</label>
            <input
              type="text"
              placeholder="Nom"
              className="w-full p-2 border rounded-md"
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}
            />
          </div>
        </div>

        {/* Entreprise */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Entreprise</label>
          <input
            type="text"
            placeholder="Nom de l'entreprise"
            className="w-full p-2 border rounded-md"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
          />
        </div>
        
        {/* Code Immeuble */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Code Immeuble</label>
          <input
            type="text"
            placeholder="Code immeuble à 6 caractères"
            className="w-full p-2 border rounded-md"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            maxLength={6}
          />
          {errorCodeImmeuble && (
            <p className="text-red-500 text-sm mt-1">{errorCodeImmeuble}</p>
          )}
          {successCodeImmeuble && (
            <p className="text-green-500 text-sm mt-1">{successCodeImmeuble}</p>
          )}
        </div>
        
        {/* Adresse (visible après validation du code) */}
        {addressVisible && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Adresse</label>
            <input
              type="text"
              className="w-full p-2 border rounded-md bg-gray-100"
              value={address}
              readOnly
            />
            
            {city && zip && (
              <>
                <div className="mt-3">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ville</label>
                  <input
                    type="text"
                    className="w-full p-2 border rounded-md bg-gray-100"
                    value={city}
                    readOnly
                  />
                </div>
                
                <div className="flex space-x-4 mt-3">
                  <div className="w-1/2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Code Postal</label>
                    <input
                      type="text"
                      className="w-full p-2 border rounded-md bg-gray-100"
                      value={zip}
                      readOnly
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        
        {/* Téléphone */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Téléphone</label>
          <input
            type="tel"
            placeholder="0612345678"
            className="w-full p-2 border rounded-md"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            maxLength={10}
          />
        </div>
        
        {/* Email */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="email"
            placeholder="exemple@email.com"
            className="w-full p-2 border rounded-md"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        
        {/* Mot de passe */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Mot de passe</label>
          <div className="flex">
            <input
              type={passwordType}
              placeholder="Mot de passe"
              className="w-full p-2 border rounded-md"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span className="flex justify-around items-center" onClick={handleTogglePassword}>
              <Icon className="absolute mr-10" icon={passwordIcon} size={24} />
            </span>
          </div>
        </div>
        
        {/* Confirmation mot de passe */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Confirmation mot de passe</label>
          <div className="flex">
            <input
              type={confirmPasswordType}
              placeholder="Confirmer le mot de passe"
              className="w-full p-2 border rounded-md"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <span className="flex justify-around items-center" onClick={handleToggleConfirmPassword}>
              <Icon className="absolute mr-10" icon={confirmPasswordIcon} size={24} />
            </span>
          </div>
        </div>

        <div className="mb-4 space-y-3">
          <label className="flex cursor-pointer items-start gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={acceptedCgu}
              onChange={(e) => setAcceptedCgu(e.target.checked)}
              className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary"
            />
            <span>
              J&apos;accepte les{" "}
              <a
                href={LEGAL_URLS.CGU}
                target="_blank"
                rel="noreferrer"
                className="text-cyan-600 underline hover:text-cyan-800"
                onClick={(e) => e.stopPropagation()}
              >
                CGU
              </a>
              <span className="text-red-500"> *</span>
            </span>
          </label>

          <label className="flex cursor-pointer items-start gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={acceptedPrivacyPolicy}
              onChange={(e) => setAcceptedPrivacyPolicy(e.target.checked)}
              className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary"
            />
            <span>
              J&apos;accepte la{" "}
              <a
                href={LEGAL_URLS.PRIVACY_POLICY}
                target="_blank"
                rel="noreferrer"
                className="text-cyan-600 underline hover:text-cyan-800"
                onClick={(e) => e.stopPropagation()}
              >
                politique de confidentialité
              </a>
              <span className="text-red-500"> *</span>
            </span>
          </label>

          {isRentalManagerSignup && (
            <label className="flex cursor-pointer items-start gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={acceptedSubcontracting}
                onChange={(e) => setAcceptedSubcontracting(e.target.checked)}
                className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary"
              />
              <span>
                J&apos;accepte l&apos;
                <a
                  href={LEGAL_URLS.SUBCONTRACTING_AGREEMENT}
                  target="_blank"
                  rel="noreferrer"
                  className="text-cyan-600 underline hover:text-cyan-800"
                  onClick={(e) => e.stopPropagation()}
                >
                  accord de sous-traitance
                </a>
                <span className="text-red-500"> *</span>
              </span>
            </label>
          )}
        </div>
        
        {/* Message d'erreur */}
        {error && (
          <p className="text-red-500 text-sm mt-2 text-center">{error}</p>
        )}
        
        {/* Bouton de validation */}
        <button
          onClick={handleSignup}
          disabled={loading}
          className="w-full bg-primary text-white p-2 rounded-md hover:bg-opacity-80 mt-4"
        >
          {loading ? "Création en cours..." : "Créer mon compte"}
        </button>
        
        {/* Lien vers la connexion */}
        <div className="mt-4 text-center">
          <p className="text-sm">Vous avez déjà un compte ?</p>
          <a 
            onClick={() => navigate('/login')} 
            className="cursor-pointer text-cyan-500 text-sm underline mt-2 italic"
          >
            Se connecter
          </a>
        </div>
      </div>
    </div>
  );
}

export default SignUp;